import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';
const CONDITION_LABELS = { neuf:"Comme neuf", bon:"Bon etat", moyen:"Etat moyen", pieces:"Pour pieces" };
const SERVICE_LABELS = { sav:"SAV", livraison:"Livraison", montage:"Montage" };
const SPEC_LABELS = {
  fauteuil_dentaire:"Fauteuil", radiologie:"Radiologie", turbine_contre_angle:"Turbines",
  sterilisation_autoclave:"Stérilisation", compresseur:"Compresseur", aspiration:"Aspiration",
  unite_dentaire:"Unité dentaire", scanner_cao_cam:"Scanner/CAO", electronique_generale:"Électronique",
  plomberie_circuits_eau:"Plomberie", autre:"Autre",
};
const img = (u) => u && u.startsWith('/api') ? API + u : u;

const STATUS_BADGE = {
  approved: "text-green-700 bg-green-100",
  pending:  "text-amber-700 bg-amber-100",
  rejected: "text-red-700 bg-red-100",
};

const MarketplaceTab = () => {
  const [sub, setSub] = useState("listings");
  const [listings, setListings] = useState([]);
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = () => localStorage.getItem('dz_token');

  const load = async () => {
    setLoading(true);
    try {
      const [l, r] = await Promise.all([
        fetch(API + "/api/admin/occasion/all", { headers: { "Authorization": "Bearer " + token() } }),
        fetch(API + "/api/admin/reparateurs/all", { headers: { "Authorization": "Bearer " + token() } }),
      ]);
      if (l.ok) setListings(await l.json());
      if (r.ok) setReps(await r.json());
    } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const action = async (type, id, act, reason) => {
    try {
      const url = API + `/api/admin/${type}/${id}/${act}`;
      const opts = { method: "PATCH", headers: { "Authorization": "Bearer " + token(), "Content-Type": "application/json" } };
      if (reason) opts.body = JSON.stringify({ reason });
      const r = await fetch(url, opts);
      if (r.ok) load();
    } catch {}
  };

  const deleteListing = async (id) => {
    if (!window.confirm("Supprimer définitivement cette annonce ?")) return;
    try {
      const r = await fetch(API + "/api/occasion/listings/" + id, { method: "DELETE", headers: { "Authorization": "Bearer " + token() } });
      if (r.ok) load();
    } catch {}
  };

  return (
    <div>
      <div className="flex gap-2 mb-5">
        <button onClick={() => setSub("listings")} className={"px-4 py-2 rounded-lg text-sm font-medium " + (sub === "listings" ? "bg-[#1F4D3F] text-white" : "bg-white border border-[#E8E0D0] text-[#5A5247]")}>
          📦 Annonces occasion ({listings.length})
        </button>
        <button onClick={() => setSub("reps")} className={"px-4 py-2 rounded-lg text-sm font-medium " + (sub === "reps" ? "bg-[#1F4D3F] text-white" : "bg-white border border-[#E8E0D0] text-[#5A5247]")}>
          🔧 Réparateurs ({reps.length})
        </button>
      </div>

      {loading ? <div className="text-center py-12 text-[#9A8F82]">Chargement...</div> : sub === "listings" ? (
        listings.length === 0 ? <div className="text-center py-12 text-[#9A8F82]">Aucune annonce</div> : (
          <div className="space-y-3">
            {listings.map(l => (
              <div key={l.id} className="bg-white border border-[#E8E0D0] rounded-xl p-4">
                <div className="flex gap-4">
                  <div className="w-20 h-20 rounded-lg bg-[#F5F1EA] flex items-center justify-center overflow-hidden shrink-0">
                    {l.images && l.images.length > 0 ? <img src={img(l.images[0])} alt="" className="w-full h-full object-cover" /> : <span className="text-3xl">📦</span>}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-semibold text-[#2D2A26]">{l.title}</h3>
                      <span className={"text-xs px-2 py-0.5 rounded-full " + (STATUS_BADGE[l.status] || "")}>{l.status}</span>
                    </div>
                    <div className="text-sm text-[#7A6F5C] mb-1">
                      {l.price ? Math.round(l.price).toLocaleString("fr") + " DA" : "Prix sur demande"} · {l.brand || "—"} · {CONDITION_LABELS[l.condition] || l.condition}
                    </div>
                    <div className="text-sm text-[#5A5247] mb-1">📍 {l.wilaya} {l.city && "· " + l.city}</div>
                    <div className="flex items-center gap-3 text-sm">
                      <span className="text-[#1F4D3F] font-medium">👤 {l.seller_name}</span>
                      {l.contact_phone && <a href={"tel:" + l.contact_phone} className="text-[#C75B27] font-medium">📞 {l.contact_phone}</a>}
                    </div>
                    {(l.services || []).length > 0 && (
                      <div className="flex gap-1 mt-1">
                        {l.services.map(s => <span key={s} className="text-xs bg-[#E4EDE9] text-[#1F4D3F] px-2 py-0.5 rounded-full">{SERVICE_LABELS[s] || s}</span>)}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-2 shrink-0">
                    {l.status !== "approved" && <button onClick={() => action("occasion", l.id, "approve")} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium">Approuver</button>}
                    {l.status !== "rejected" && <button onClick={() => action("occasion", l.id, "reject", "Non conforme")} className="bg-amber-500 text-white px-3 py-1.5 rounded-lg text-xs font-medium">Rejeter</button>}
                    <button onClick={() => deleteListing(l.id)} className="border border-red-300 text-red-600 px-3 py-1.5 rounded-lg text-xs font-medium">Supprimer</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        reps.length === 0 ? <div className="text-center py-12 text-[#9A8F82]">Aucun réparateur</div> : (
          <div className="space-y-3">
            {reps.map(r => (
              <div key={r.id} className="bg-white border border-[#E8E0D0] rounded-xl p-4">
                <div className="flex gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#1F4D3F] flex items-center justify-center text-white text-xl font-bold shrink-0">{(r.name || "?")[0].toUpperCase()}</div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-semibold text-[#2D2A26]">{r.name}</h3>
                      <span className={"text-xs px-2 py-0.5 rounded-full " + (STATUS_BADGE[r.status] || "")}>{r.status}</span>
                    </div>
                    {r.phone && <a href={"tel:" + r.phone} className="text-[#C75B27] font-medium text-sm block mb-1">📞 {r.phone}</a>}
                    {r.description && <p className="text-sm text-[#5A5247] mb-2">{r.description}</p>}
                    <div className="flex flex-wrap gap-1 mb-1">
                      {(r.specialites || []).map(s => <span key={s} className="text-xs bg-[#E4EDE9] text-[#1F4D3F] px-2 py-0.5 rounded-full">{SPEC_LABELS[s] || s}</span>)}
                    </div>
                    <div className="text-xs text-[#9A8F82]">Zones : {(r.wilayas_couvertes || []).join(", ")}</div>
                  </div>
                  <div className="flex flex-col gap-2 shrink-0">
                    {r.status !== "approved" && <button onClick={() => action("reparateurs", r.id, "approve")} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium">Approuver</button>}
                    {r.status !== "rejected" && <button onClick={() => action("reparateurs", r.id, "reject", "Non conforme")} className="bg-amber-500 text-white px-3 py-1.5 rounded-lg text-xs font-medium">Rejeter</button>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default MarketplaceTab;
